import { render, staticRenderFns } from "./AddSourceGroup.vue?vue&type=template&id=3e05ddfa&scoped=true"
import script from "./AddSourceGroup.vue?vue&type=script&lang=js"
export * from "./AddSourceGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e05ddfa",
  null
  
)

export default component.exports